import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _reverseInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reverse";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _parseFloat from "@babel/runtime-corejs3/core-js/parse-float";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as FieldComponents from "@Shared/components/sections/index";
import { ADD_APPLICATION_GROUP, REMOVE_APPLICATION_GROUP } from "../../../store/application-actions";
import { MORTGAGE_TYPE_PARSER } from "@Shared/js/constants";
import { PUSH_MORTGAGE_SUBMISSION, UPDATE_SUBMISSION_INSURED, UPDATE_SUBMISSION_INCLUDE_INSURANCE_IN_MORTGAGE, RESET_MORTGAGE_INFORMATION, RESET_SUBMISSION_INFORMATION, SET_APPLICATION_WITH_DEFAULTS_FOR_PAGE } from "../../../store/application-mutations";
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { createHelpers } from "@joandvgv/vuex-map-fields";
import SubmissionDetails from "./sub-pages/submission-details.vue";
import DuplicatorMixin from "@Shared/utils/application-mixins/duplicator-mixin";
import MortgageDetailsMixin from "@Broker/@Modules/clients/applications/application/select-options/mortgage-details-mixin";
import VisibilityToggleMixin from "@Shared/utils/application-mixins/visibility-toggle-mixin";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import { calculateMortgageAmountValue } from "@Shared/@Utils/utils";
import { cloneDeep, invert, isEmpty, kebabCase, mapValues } from "lodash";
import { ACCEPTED_LENDER_SUBMISSION_BY_MORTGAGE_TYPE } from "../../../store/lender-submit-getters";
import { APPLICATION_CLIENT_DETAILS, CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES, CO_BROKERED_MORTGAGES } from "../../../store/application-getters";
import { DEFAULT_LOAN_TYPE_VALUE } from "@Shared/@Utils/application-defaults-utils/application-default-values-constants";
import { PagesVisibilityMap } from "@Broker/@Utils/application/pages-visibility-map.ts";
import MultipleVisibilityButton from "@Broker/@Modules/clients/applications/application/components/pages-components/application/util-components/multiple-visibility-button.vue";
const {
  mapFields,
  mapMultiRowFields
} = createHelpers({
  getterType: "getDetails",
  mutationType: "setDetails"
});
const root = "mortgage-details";
const mortgage = "mortgage-details[mortgage-details]";
const classifications = "submission-details[mortgage-classifications]";
const property = "property[details]";
const paths = {
  closingDate: mortgage,
  financingWaiver: mortgage,
  purpose: mortgage,
  improvements: mortgage,
  improvementsValue: mortgage,
  improvementsDescription: mortgage,
  commercial: classifications,
  construction: classifications,
  reverse: classifications,
  subprime: classifications,
  heloc: classifications,
  qualifiedSyndicated: classifications,
  nonQualifiedSyndicated: classifications,
  bridgeloan: classifications,
  suspicioustransaction: classifications,
  purchasePrice: property,
  estimatedValue: property,
  appraisedValue: property,
  propertyValueIndex: property,
  downPayment: root,
  mortgages: root
};
export const propertyIndexParser = {
  A: "appraisedValue",
  E: "estimatedValue",
  P: "purchasePrice"
};
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MortgageDetails",
  components: _objectSpread(_objectSpread({
    SubmissionDetails
  }, FieldComponents), {}, {
    InlinePrompt,
    MultipleVisibilityButton
  }),
  mixins: [DuplicatorMixin, MortgageDetailsMixin, VisibilityToggleMixin],
  props: {
    currentApplication: {
      type: Object,
      default: () => ({})
    },
    editVisibility: {
      type: Boolean,
      default: false
    },
    clientUsername: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      PagesVisibilityMap,
      editableCalculatedValues: {},
      mortgageIndexMap: {
        0: "first",
        1: "second",
        2: "third"
      }
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    visibilityPaths() {
      return mapValues(paths, (path, key) => `${path}[${kebabCase(key)}]`);
    }
  }, mapState("ApplicationStore", {
    calculatedValuesFromStore(state) {
      return state.calculatedValues;
    },
    emptyApplication(state) {
      return state.emptyApplication;
    },
    emptyCalculatedValues(state) {
      return state.emptyCalculatedValues;
    }
  })), mapFields("ApplicationStore", {
    closingDate: () => paths.closingDate,
    financingWaiver: () => paths.financingWaiver,
    purpose: () => paths.purpose,
    lender: () => paths.lender,
    mortgageType: () => paths.mortgageType,
    loanType: () => paths.loanType,
    interestAdjustmentDate: () => paths.interestAdjustmentDate,
    firstPaymentDate: () => paths.firstPaymentDate,
    maturityDate: () => paths.maturityDate,
    interestAdjustmentAmount: () => paths.interestAdjustmentAmount,
    lineOfBusiness: () => paths.lineOfBusiness,
    progressAdvance: () => paths.progressAdvance,
    amortizationMonths: () => paths.amortizationMonths,
    amortizationYears: () => paths.amortizationYears,
    blendedAmortization: () => paths.blendedAmortization,
    buyDownRate: () => paths.buyDownRate,
    compoundedPeriod: () => paths.compoundedPeriod,
    insured: () => paths.insured,
    includeInMortgage: () => paths.includeInMortgage,
    premiumRate: () => paths.premiumRate,
    interestRate: () => paths.interestRate,
    discountRate: () => paths.discountRate,
    rateType: () => paths.rateType,
    locRepaymentType: () => paths.locRepaymentType,
    termType: () => paths.termType,
    frequency: () => paths.frequency,
    termYears: () => paths.termYears,
    termMonths: () => paths.termMonths,
    interestOnly: () => paths.interestOnly,
    commercial: () => paths.commercial,
    construction: () => paths.construction,
    reverse: () => _reverseInstanceProperty(paths),
    subprime: () => paths.subprime,
    heloc: () => paths.heloc,
    qualifiedSyndicated: () => paths.qualifiedSyndicated,
    nonQualifiedSyndicated: () => paths.nonQualifiedSyndicated,
    bridgeloan: () => paths.bridgeloan,
    suspicioustransaction: () => paths.suspicioustransaction,
    purchasePrice: () => paths.purchasePrice,
    estimatedValue: () => paths.estimatedValue,
    appraisedValue: () => paths.appraisedValue,
    propertyValueIndex: () => paths.propertyValueIndex,
    improvements: () => paths.improvements,
    improvementsValue: () => paths.improvementsValue,
    improvementsDescription: () => paths.improvementsDescription
  })), mapMultiRowFields("ApplicationStore", {
    downPayment: () => paths.downPayment,
    mortgages: () => paths.mortgages,
    submissionDetails: () => paths.submissionDetails
  })), mapGetters("ApplicationStore", [ACCEPTED_LENDER_SUBMISSION_BY_MORTGAGE_TYPE, CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES, APPLICATION_CLIENT_DETAILS, CO_BROKERED_MORTGAGES])), {}, {
    currentClientDetails() {
      return this.APPLICATION_CLIENT_DETAILS(this.clientUsername);
    },
    calculatedValues() {
      return this.editVisibility ? this.emptyCalculatedValues : this.calculatedValuesFromStore;
    },
    anyAcceptedLenderSubmission() {
      return !isEmpty(this.ACCEPTED_LENDER_SUBMISSION_BY_MORTGAGE_TYPE);
    },
    disabledByAcceptedSubmissionIcon() {
      return this.anyAcceptedLenderSubmission ? "fa-info-circle" : "";
    },
    disabledByAcceptedSubmissionTooltipText() {
      return this.anyAcceptedLenderSubmission ? this.$t("application-flow.messages.disabled-by-accepted-submission") : "";
    },
    disabledByAcceptedSubmissionInputByMortgage() {
      var _context;
      if (!this.anyAcceptedLenderSubmission) return {};
      return _reduceInstanceProperty(_context = _Object$keys(this.ACCEPTED_LENDER_SUBMISSION_BY_MORTGAGE_TYPE)).call(_context, (acc, mortgageType) => {
        acc[mortgageType] = true;
        return acc;
      }, {});
    },
    disabledByAcceptedSubmissionIconByMortgage() {
      var _context2;
      if (!this.anyAcceptedLenderSubmission) return {};
      return _reduceInstanceProperty(_context2 = _Object$keys(this.ACCEPTED_LENDER_SUBMISSION_BY_MORTGAGE_TYPE)).call(_context2, (acc, mortgageType) => {
        acc[mortgageType] = "fa-info-circle";
        return acc;
      }, {});
    },
    disabledByAcceptedSubmissionTooltipTextByMortgage() {
      var _context3;
      if (!this.anyAcceptedLenderSubmission) return {};
      return _reduceInstanceProperty(_context3 = _Object$keys(this.ACCEPTED_LENDER_SUBMISSION_BY_MORTGAGE_TYPE)).call(_context3, (acc, mortgageType) => {
        acc[mortgageType] = this.$t("application-flow.messages.disabled-by-accepted-submission");
        return acc;
      }, {});
    },
    requestedOptionsByFlow() {
      var _context4, _context5;
      if (this.allowForExistingMortgages) return this.mortgageRequestedOptions; // It's an allowed flow

      if (this.hasCoBrokeredMortgages)
        // It's not an allowed flow but has co-brokered mortgages
        return _mapInstanceProperty(_context4 = this.mortgageRequestedOptions).call(_context4, option => _objectSpread(_objectSpread({}, option), {}, {
          disabled: option.value === "existing"
        }));

      // It's not an allowed flow and it doesn't have co-brokered mortgages
      return _filterInstanceProperty(_context5 = this.mortgageRequestedOptions).call(_context5, option => option.value !== "existing");
    },
    submissionDetails() {
      return this.currentApplication["submission-details"];
    },
    propertyValue: {
      get() {
        if (this.propertyValueIndex) {
          const valueToUse = propertyIndexParser[this.propertyValueIndex];
          return this[valueToUse];
        }
        return this.purchasePrice;
      },
      set(value) {
        const {
          downpaymentAmount
        } = this.editableCalculatedValues;
        if (this.propertyValueIndex) {
          const valueToUse = propertyIndexParser[this.propertyValueIndex];
          this[valueToUse] = value;
        } else {
          this.purchasePrice = value;
        }
        this.editableCalculatedValues.downpaymentPercent = _parseFloat(downpaymentAmount) * 100 / _parseFloat(value);
      }
    },
    syncedPropertyValue() {
      const propertyIndexParser = {
        A: this.appraisedValue,
        E: this.estimatedValue,
        P: this.purchasePrice
      };
      return propertyIndexParser[this.propertyIndex] || this.purchasePrice;
    },
    firstMortgageInsured() {
      return this.mortgages[0]["insured"];
    },
    secondMortgageInsured() {
      return this.mortgages[1]["insured"];
    },
    thirdMortgageInsured() {
      return this.mortgages[2]["insured"];
    },
    currentEmptyApplication() {
      return cloneDeep(this.emptyApplication[this.currentApplication.flow]);
    },
    allowForExistingMortgages() {
      const allowedFlows = ["refinance-approval", "switch-transfer"];
      return _includesInstanceProperty(allowedFlows).call(allowedFlows, this.currentApplication.flow);
    },
    showDownPaymentCalculator() {
      return this.propertyValueEntered() && this.atLeastOneRequestedMortgageWithAmount();
    },
    hasCoBrokeredMortgages() {
      return !isEmpty(this.CO_BROKERED_MORTGAGES);
    }
  }),
  watch: {
    firstMortgageInsured(value) {
      this.UPDATE_SUBMISSION_INSURED({
        index: 0,
        value
      });
      this.UPDATE_SUBMISSION_INCLUDE_INSURANCE_IN_MORTGAGE({
        index: 0,
        value
      });
    },
    secondMortgageInsured(value) {
      this.UPDATE_SUBMISSION_INSURED({
        index: 1,
        value
      });
      this.UPDATE_SUBMISSION_INCLUDE_INSURANCE_IN_MORTGAGE({
        index: 1,
        value
      });
    },
    thirdMortgageInsured(value) {
      this.UPDATE_SUBMISSION_INSURED({
        index: 2,
        value
      });
      this.UPDATE_SUBMISSION_INCLUDE_INSURANCE_IN_MORTGAGE({
        index: 2,
        value
      });
    }
  },
  mounted() {
    if (!this.editVisibility) this.setEditableCalculatedValues();
    this.mortgagesAmountToZero();
    this.checkMortgagesRequestedValues();
    this.calculateMortgageDownpayment();
    this.calculateDownpayment(this.editableCalculatedValues.downpaymentAmount, "downpaymentPercent");
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("ApplicationStore", [ADD_APPLICATION_GROUP, REMOVE_APPLICATION_GROUP])), mapMutations("ApplicationStore", [PUSH_MORTGAGE_SUBMISSION, UPDATE_SUBMISSION_INSURED, UPDATE_SUBMISSION_INCLUDE_INSURANCE_IN_MORTGAGE, RESET_MORTGAGE_INFORMATION, RESET_SUBMISSION_INFORMATION, SET_APPLICATION_WITH_DEFAULTS_FOR_PAGE])), {}, {
    handleVisibility(data) {
      this.$emit("toggle-visibility", data);
    },
    handleDuplicate({
      what,
      where
    }) {
      this.ADD_APPLICATION_GROUP({
        what,
        where
      });
      this.$emit("save");
    },
    handleRemove(index, removePath) {
      this.REMOVE_APPLICATION_GROUP({
        index,
        where: removePath
      });
      this.$emit("save");
    },
    handleSave() {
      this.$emit("save");
    },
    setEditableCalculatedValues() {
      this.editableCalculatedValues = cloneDeep(this.calculatedValues);
      const applicationDownpaymentValue = this.currentApplication["mortgage-details"]["down-payment"][0]["amount"];
      if (applicationDownpaymentValue) {
        this.editableCalculatedValues.downpaymentAmount = _parseFloat(applicationDownpaymentValue);
      }

      //this means the application is submitted or changed by the client on the client portal
      const clientAccountIsActive = this.currentClientDetails.accountStatus === "active";

      //We check for requested mortgages, because when there's one, the calculator appears on the downpayment field
      if (!this.editVisibility && clientAccountIsActive && !this.CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES && applicationDownpaymentValue) {
        this.calculateDownpayment(applicationDownpaymentValue, "downpaymentPercent");
      }
    },
    calculateDownpayment(value, type) {
      const floatValue = _parseFloat(value);
      const floatPropertyValue = _parseFloat(this.propertyValue);
      const formulaParser = {
        downpaymentPercent: floatValue * 100 / floatPropertyValue,
        downpaymentAmount: floatPropertyValue * (floatValue / 100)
      };
      this.editableCalculatedValues[type] = formulaParser[type];
      this.editableCalculatedValues.downpaymentAmount = _parseFloat(this.editableCalculatedValues.downpaymentAmount);
    },
    calculateMortgageAmount(mortgageIdx) {
      var _context6;
      const selectedMortgage = this.mortgages[mortgageIdx];
      const remainingMortgagesAmount = _reduceInstanceProperty(_context6 = this.mortgages).call(_context6, (acc, {
        amount
      }, index) => {
        if (index === mortgageIdx) return acc;
        return acc + Number(amount);
      }, 0);
      selectedMortgage.amount = calculateMortgageAmountValue(this.propertyValue, this.editableCalculatedValues.downpaymentAmount, remainingMortgagesAmount).replace("-", "");
      this.$emit("save");
    },
    totalAmountCondition(index) {
      return this.mortgages[index]["insured"] && this.mortgages[index].requested === "requested";
    },
    mortgagesAmountToZero() {
      this.mortgages.forEach(mortgage => {
        if (mortgage.amount === "") mortgage.amount = 0;
      });
    },
    handleChangedToExisting(index) {
      var _context7;
      const submissionDetailsAssociated = _findIndexInstanceProperty(_context7 = this.submissionDetails).call(_context7, submission => {
        const mortgageType = submission["submission-details"]["mortgage-type"];
        return MORTGAGE_TYPE_PARSER[mortgageType] === index;
      });
      if (this.mortgages[index].requested === "") this.mortgages[index].insured = false;
      this.SET_APPLICATION_WITH_DEFAULTS_FOR_PAGE({
        page: "property",
        triggerOnSave: true
      });
      const structure = cloneDeep(this.emptyApplication[this.currentApplication.flow]["submission-details"][0]);
      if (submissionDetailsAssociated === -1) return;
      if (this.submissionDetails.length === 1) {
        this.RESET_SUBMISSION_INFORMATION({
          index: submissionDetailsAssociated,
          structure: _objectSpread(_objectSpread({}, structure), {}, {
            amount: 0
          })
        });
      } else {
        this.REMOVE_APPLICATION_GROUP({
          index: submissionDetailsAssociated,
          where: "[submission-details]"
        });
      }
    },
    handleAddMortgage(index, value, save = true) {
      var _context8;
      if (value !== "requested") return this.handleChangedToExisting(index);
      const currentMortgageType = invert(MORTGAGE_TYPE_PARSER)[index];
      const limitReached = this.submissionDetails.length === 3;
      const alreadyExists = index !== null && _findInstanceProperty(_context8 = this.submissionDetails).call(_context8, submission => submission["submission-details"]["mortgage-type"] === currentMortgageType);
      if (limitReached || alreadyExists) return;
      const submissionDetailsStructure = this.currentEmptyApplication["submission-details"][0];
      submissionDetailsStructure["submission-details"]["loan-type"] = DEFAULT_LOAN_TYPE_VALUE;
      this.PUSH_MORTGAGE_SUBMISSION({
        index,
        structure: submissionDetailsStructure
      });
      if (value === "requested") {
        this.SET_APPLICATION_WITH_DEFAULTS_FOR_PAGE({
          page: "property",
          triggerOnSave: true
        });
      }
      if (save) this.$emit("save");
    },
    navigateTitle(index) {
      if (index === 0 && !this.submissionDetails[0]["submission-details"]["mortgage-type"]) return true;
      return this.submissionDetails.some(submission => submission["submission-details"]["mortgage-type"] === invert(MORTGAGE_TYPE_PARSER)[index]);
    },
    navigateTo(element, duration = 500) {
      this.$nextTick(() => {
        this.$scrollTo(`#${element}`, duration, {
          container: "#app-data-container",
          force: true,
          cancelable: true
        });
      });
    },
    getCalculatedValues(mortgageType) {
      const {
        mortgageValues
      } = this.calculatedValues;
      return mortgageValues == null ? void 0 : _findInstanceProperty(mortgageValues).call(mortgageValues, item => item.mortgageType === mortgageType);
    },
    totalLoanAmount(mortgageType) {
      var _calculation$totalLoa;
      const calculation = this.getCalculatedValues(mortgageType);
      return (_calculation$totalLoa = calculation == null ? void 0 : calculation.totalLoanAmount) != null ? _calculation$totalLoa : 0;
    },
    getMortgageData(mortgage) {
      const mortgageType = mortgage["submission-details"]["mortgage-type"];
      return this.mortgages[MORTGAGE_TYPE_PARSER[mortgageType]];
    },
    checkMortgagesRequestedValues() {
      this.mortgages.forEach((mortgage, index) => {
        if (mortgage.requested) {
          this.handleAddMortgage(index, mortgage.requested, false);
        }
      });
    },
    copyTotalDownPaymentToClosingDetails() {
      const {
        totalDownpaymentAmount
      } = this.calculatedValues;
      this.editableCalculatedValues.downpaymentAmount = totalDownpaymentAmount;
      this.calculateDownpayment(totalDownpaymentAmount, "downpaymentPercent");
    },
    propertyValueEntered() {
      return this.propertyValue.length > 0 && this.propertyValue != "0.00";
    },
    atLeastOneRequestedMortgageWithAmount() {
      return this.isRequestedMortgageWithAmount(0) || this.isRequestedMortgageWithAmount(1) || this.isRequestedMortgageWithAmount(2);
    },
    isRequestedMortgageWithAmount(index) {
      return this.mortgages[index].amount != "0.00" && this.mortgages[index].requested === "requested";
    },
    calculateMortgageDownpayment() {
      if (this.atLeastOneRequestedMortgageWithAmount()) {
        if (!this.checkBeforeCalculateDownpayment()) {
          let requestedMortgagesSum = 0;
          this.mortgages.forEach(mortgage => {
            if (mortgage.requested) requestedMortgagesSum += _parseFloat(mortgage.amount);
          });
          this.editableCalculatedValues.downpaymentAmount = this.propertyValue - requestedMortgagesSum;
          this.calculateDownpayment(this.editableCalculatedValues.downpaymentAmount, "downpaymentPercent");
        }
      } else {
        this.editableCalculatedValues.downpaymentAmount = 0;
      }
    },
    checkBeforeCalculateDownpayment() {
      const downPayment = _parseFloat(this.editableCalculatedValues.downpaymentAmount);
      let requestedMortgagesSum = 0;
      this.mortgages.forEach(mortgage => {
        requestedMortgagesSum += _parseFloat(mortgage.amount);
      });
      return downPayment + requestedMortgagesSum === _parseFloat(this.propertyValue);
    },
    isMortgageCoBrokered(mortgageIndex) {
      var _context9;
      const mortgageType = this.mortgageIndexMap[mortgageIndex];
      const {
        isCobrokeredApplication
      } = this.currentApplication;
      const mortgageIncludedInCobroker = !!(this.CO_BROKERED_MORTGAGES && _includesInstanceProperty(_context9 = this.CO_BROKERED_MORTGAGES).call(_context9, mortgageType));
      return isCobrokeredApplication ? !mortgageIncludedInCobroker : mortgageIncludedInCobroker;
    }
  })
});